import UserModel from "./UserModel";
import TutorModel from "./TutorModel";
import SponsorshipModel from "./SponsorshipModel";
import SponsorModel from "./SponsorModel";
import moment, { Moment } from "moment-timezone";
import ApiDateParser from "../../helpers/parsers/apiDateParser";
import { isValidMoment } from "../../helpers/date_helpers";
import TelawahModel from "./TelawahModel";
import StudentStatisticsModel from "./StudentStatisticsModel";

export default class StudentBaseModel extends UserModel {
  motherLanguage?: string;
  residenceCountry?: string;
  failedNotes?: string;
  passedNotes?: string;
  phoneNumber?: string;
  recitation?: string;
  isLearner?: boolean;
  tutorGender?: string;
  telawah?: TelawahModel;
  sponsorship?: SponsorshipModel;
  sponsor?: SponsorModel;
  finished_sessions_count?: number;
  total_sessions_count?: number;
  programName?: string;
  reachedScheduleRequestsLimit: boolean;
  hasRecitationSchedule: string;
  cancelled_sessions_count?: number;
  private __weeklySessionsCount?: number;
  private __lastQuranPageReached?: number;
  private __firstSessionDate?: Moment | null;
  completed_sessions_count?: number;
  learn_dash_progresses?: [];
  student_statistic?: StudentStatisticsModel;

  constructor(arg: any) {
    super(arg);
    this.motherLanguage = arg.native_language;
    this.hasRecitationSchedule = arg?.has_recitation_schedule ?? "";
    this.reachedScheduleRequestsLimit =
      arg?.reached_schedule_requests_limit ?? "";
    this.phoneNumber = arg.phone_number;
    this.recitation = arg.recitation;
    this.tutorGender = arg.tutor_gender_preference;
    this.finished_sessions_count = arg.finished_sessions_count;
    this.total_sessions_count = arg.total_sessions_count;
    this.cancelled_sessions_count = arg.cancelled_sessions_count;
    this.__weeklySessionsCount = arg.weekly_sessions_count;
    this.__lastQuranPageReached = arg.last_quran_page_reached;
    this.completed_sessions_count = arg.completed_sessions_count;
    this.__firstSessionDate = ApiDateParser.parse(arg.date_of_first_session);
    this.fullName = arg.full_name ?? arg?.first_name + " " + arg?.last_name;
    this.gender = arg.gender;
    this.failedNotes = arg.notes_statistics?.failed_notes;
    this.passedNotes = arg.notes_statistics?.passed_notes;
    this.residenceCountry = arg.residence_country;
    this.telawah = arg?.telawah;
    this.isLearner = arg?.is_learner ?? false;
    this.programName = arg?.program_name ?? "";
    this.learn_dash_progresses = arg?.learn_dash_progresses ?? [];
    if (!!arg.sponsor) this.sponsor = SponsorModel.fromApiResponse(arg.sponsor);
    if (!!arg.sponsorship)
      this.sponsorship = SponsorshipModel.fromApiResponse(arg.sponsorship);
    if (!!arg.student_statistic)
    this.student_statistic = StudentStatisticsModel.fromApiResponse(arg!.student_statistic);
  }
  get sponsorName(): string {
    let val = "";
    if (
      !!this.sponsorship &&
      !Array.isArray(this.sponsorship) &&
      !!this.sponsorship.sponsor
    ) {
      val = this.sponsorship.sponsor.name || "";
    }
    return val;
  }

  get weeklySessionsCount(): number | null {
    return this.__weeklySessionsCount || null;
  }
  get lastQuranPageReached(): number {
    return this.__lastQuranPageReached || 0;
  }
  get firstSessionDate(): Moment | null {
    if (!isValidMoment(this.__firstSessionDate)) return null;
    return this.__firstSessionDate!;
  }
  get totalQuraanPages() {
    return 644;
  }
}
